import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { resetTimer } from '../../../redux/reducers/auth';
import { closeModal } from '../../../redux/reducers/modal';
// components
import Button from '../../../components/Button/Button';
// utils
import { toastResponseErrors } from '../../../utils/response';
// styles
import styles from './ResetClock.mod.css';

const ResetClock = ({ closeModal, resetTimer, modalData: { userColor } }) => {
  const submitReset = () => {
    resetTimer(new Date())
      .then(closeModal)
      .catch(toastResponseErrors);
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Reset your recovery clock</h2>
      <div className={styles.info}>
        <p className={styles.label}>
          Are you sure want to reset your recovery clock?
        </p>
      </div>
      <div className={styles.buttonSection}>
        <Button plain onClick={closeModal}>
          Cancel
        </Button>
        <Button type="submit" color={userColor} onClick={submitReset}>
          Reset
        </Button>
      </div>
    </div>
  );
};

ResetClock.propTypes = {
  closeModal: T.func.isRequired,
  resetTimer: T.func.isRequired,
  modalData: T.object.isRequired
};

export default connect(
  null,
  { resetTimer, closeModal }
)(ResetClock);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/ResetClock.jsx